// import React, { useEffect, useState, useMemo } from 'react';
// import {
//   ArrowUpFromLine, ArrowDownToLine, RotateCcw,
//   UserPlus, UserMinus, Key, ShieldOff,
//   Rocket, Edit2, Terminal, Loader2, FileJson,
//   Activity, ShieldCheck, Search, ArrowRight, Clock
// } from 'lucide-react';
// import { Link } from 'react-router-dom';
// import { projectsAPI } from '../../services/api';
// import { useAuth } from '../../context/AuthContext';

// // --- Configuration Map ---
// const ACTION_CONFIG = {
//   SECRETS_UPDATE: { icon: Edit2, color: 'text-orange-400', bg: 'bg-orange-500/10', border: 'border-orange-500/20', label: 'Vault Modified' },
//   SECRETS_PUSH: { icon: ArrowUpFromLine, color: 'text-orange-500', bg: 'bg-orange-500/10', border: 'border-orange-500/30', label: 'Console Sync' },
//   SECRETS_PULL: { icon: ArrowDownToLine, color: 'text-emerald-400', bg: 'bg-emerald-500/10', border: 'border-emerald-500/20', label: 'Vault Download' },
//   ROLLBACK: { icon: RotateCcw, color: 'text-red-400', bg: 'bg-red-500/10', border: 'border-red-500/30', label: 'Version Reversion' },
//   CLI_PUSH: { icon: Terminal, color: 'text-emerald-400', bg: 'bg-emerald-500/10', border: 'border-emerald-500/30', label: 'CLI Push Entry' },
//   CLI_PULL: { icon: Terminal, color: 'text-emerald-500', bg: 'bg-emerald-500/10', border: 'border-emerald-500/30', label: 'CLI Pull Entry' },
//   MEMBER_ADD: { icon: UserPlus, color: 'text-white', bg: 'bg-white/10', border: 'border-white/20', label: 'Access Granted' },
//   MEMBER_REMOVE: { icon: UserMinus, color: 'text-red-600', bg: 'bg-red-600/10', border: 'border-red-600/30', label: 'Access Revoked' },
//   PROJECT_CREATE: { icon: Rocket, color: 'text-orange-500', bg: 'bg-orange-500/10', border: 'border-orange-500/30', label: 'Vault Initialized' },
//   TOKEN_CREATED: { icon: Key, color: 'text-orange-300', bg: 'bg-orange-300/10', border: 'border-orange-300/20', label: 'Node Token Created' },
//   TOKEN_REVOKED: { icon: ShieldOff, color: 'text-red-500', bg: 'bg-red-500/10', border: 'border-red-500/30', label: 'Token Deleted' },
// };

// const getDefaultStyle = (action) => ({
//   icon: Activity, color: 'text-gray-500', bg: 'bg-white/5', border: 'border-white/10', label: action
// });

// export default function AuditLogs({ projectId }) {
//   const [logs, setLogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const { usage } = useAuth()

//   useEffect(() => {
//     let mounted = true;
//     projectsAPI.getLogs(projectId)
//       .then(data => {
//         if (mounted) {
//           setLogs(data);
//           setLoading(false);
//         }
//       })
//       .catch(() => { if (mounted) setLoading(false); });
//     return () => { mounted = false; };
//   }, [projectId]);
//   console.log("LOS",logs)

//   // Client-side Filter Logic
//   const filteredLogs = useMemo(() => {
//     return logs.filter(log => {
//       const searchStr = searchQuery.toLowerCase();
//       return (
//         log.action?.toLowerCase().includes(searchStr) ||
//         log.user?.name?.toLowerCase().includes(searchStr) ||
//         log.details?.toLowerCase().includes(searchStr)
//       );
//     });
//   }, [logs, searchQuery]);

//   if (loading) return (
//     <div className="flex flex-col items-center justify-center py-24 text-gray-700 gap-4">
//       <Loader2 size={24} className="animate-spin text-orange-500" />
//       <p className="text-[10px] font-black uppercase tracking-[0.3em]">Querying Ledger...</p>
//     </div>
//   );

//   return (
//     <div className="space-y-6">

//       {/* --- Section 1: Filter & Retention Header --- */}
//       <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 bg-white/[0.01] border border-white/5 p-4 rounded-[1.5rem] mx-2 md:mx-6">
//         <div className="relative group flex-1 lg:max-w-md">
//           <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-600 group-focus-within:text-orange-500 transition-colors" size={16} />
//           <input
//             type="text"
//             placeholder="Search ledger by user, action, or details..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full bg-black border border-white/10 rounded-xl pl-11 pr-4 py-3 text-[11px] text-white outline-none focus:border-orange-500/40 transition-all placeholder:text-gray-800"
//           />
//         </div>

//         {/* 7-Day Limit Badge */}
//         {usage?.tier == "free" && <div className="flex items-center gap-3 px-4 py-2 bg-orange-500/5 border border-orange-500/10 rounded-xl">
//           <div className="flex justify-center items-center">
//             <span className="text-[9px] font-black text-orange-500 uppercase tracking-widest leading-none pr-2">7-Day Retention</span>
//             <span className="text-[8px] text-gray-600 font-bold uppercase ">(Hobby Tier)</span>
//           </div>
//           <div className="w-px h-6 bg-white/10 mx-1" />
//           <Link to="/dashboard/subscription" className="text-[10px] font-black text-white hover:text-orange-500 transition-colors uppercase tracking-tighter flex items-center gap-1">
//             Unlock 90 days <ArrowRight size={12} />
//           </Link>
//         </div>}
//       </div>

//       {/* --- Section 2: Logs List --- */}
//       <div className="max-h-[600px] overflow-y-auto pr-2 custom-scrollbar space-y-4 md:px-6 px-2">
//         {filteredLogs.length === 0 ? (
//           <div className="flex flex-col items-center justify-center py-20 bg-white/[0.01] border border-dashed border-white/5 rounded-[2rem]">
//             <ShieldCheck size={40} className="mb-4 text-gray-800" />
//             <p className="text-[10px] font-black uppercase tracking-widest text-gray-600 text-center">
//               {searchQuery ? "No matching entries found" : "Immutable Ledger Empty"}
//             </p>
//           </div>
//         ) : (
//           <div className="space-y-3">
//             {filteredLogs.map((log) => {
//               const style = ACTION_CONFIG[log.action] || getDefaultStyle(log.action);
//               const Icon = style.icon;

//               return (
//                 <div
//                   key={log._id}
//                   className="flex flex-col md:flex-row gap-4 p-5 rounded-[1.5rem] bg-white/[0.02] border border-white/5 hover:border-white/10 transition-all duration-300 group relative overflow-hidden"
//                 >
//                   <div className={`absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 rounded-r-full ${style.color.replace('text-', 'bg-')} opacity-40`} />

//                   <div className={`p-3 rounded-xl h-fit w-fit ${style.bg} ${style.color} border border-white/5 shrink-0 group-hover:scale-105 transition-transform`}>
//                     <Icon size={18} />
//                   </div>

//                   <div className="flex-1 min-w-0 space-y-1">
//                     <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
//                       <div className="flex items-center gap-3">
//                         <p className="text-sm font-black text-white tracking-tight">{style.label}</p>
//                         <span className={`hidden md:inline text-[8px] px-2 py-0.5 rounded-md border font-black uppercase tracking-widest ${style.bg} ${style.color} ${style.border}`}>
//                           {log.action}
//                         </span>
//                       </div>
//                       <span className="text-[10px] text-gray-600 font-black uppercase tracking-widest">
//                         {new Date(log.createdAt).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
//                       </span>
//                     </div>

//                     <p className="text-xs text-gray-500 font-medium leading-relaxed">
//                       {log.details || 'System operation executed successfully.'}
//                     </p>

//                     <div className="flex items-center gap-3 mt-3 pt-3 border-t border-white/[0.03]">
//                       <div className="w-5 h-5 rounded-md bg-white/5 border border-white/10 flex items-center justify-center text-[8px] font-black text-gray-400">
//                         {log.user?.name?.charAt(0) || 'S'}
//                       </div>
//                       <p className="text-[10px] text-gray-500 font-bold uppercase tracking-wider">
//                         EXECUTED BY <span className="text-white">{log.user?.name || 'ROOT_SYSTEM'}</span>
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState, useMemo } from 'react';
import {
  ArrowUpFromLine, ArrowDownToLine, RotateCcw,
  UserPlus, UserMinus, Key, ShieldOff,
  Rocket, Edit2, Terminal, Loader2, FileJson,
  Activity, ShieldCheck, Search, ArrowRight, Clock,
  Eye, Download, Share2
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { projectsAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

// --- Configuration Map with smart categories ---
const ACTION_CONFIG = {
  // Secrets
  SECRETS_UPDATE: { icon: Edit2, color: 'text-orange-400', bg: 'bg-orange-500/10', border: 'border-orange-500/20', label: 'Vault Modified', category: 'vault' },
  SECRETS_PUSH: { icon: ArrowUpFromLine, color: 'text-orange-500', bg: 'bg-orange-500/10', border: 'border-orange-500/30', label: 'Console Sync', category: 'vault' },
  SECRETS_PULL: { icon: ArrowDownToLine, color: 'text-emerald-400', bg: 'bg-emerald-500/10', border: 'border-emerald-500/20', label: 'Vault Download', category: 'vault' },
  SECRETS_VIEW: { icon: Eye, color: 'text-blue-400', bg: 'bg-blue-500/10', border: 'border-blue-500/20', label: 'Vault Decrypted', category: 'vault' },
  ROLLBACK: { icon: RotateCcw, color: 'text-red-400', bg: 'bg-red-500/10', border: 'border-red-500/30', label: 'Version Reversion', category: 'vault' },
  // Integrations
  INTEGRATION_ADD: { icon: Rocket, color: 'text-purple-400', bg: 'bg-purple-500/10', border: 'border-purple-500/20', label: 'Integration Linked', category: 'infra' },
  INTEGRATION_REMOVE: { icon: ShieldOff, color: 'text-red-400', bg: 'bg-red-500/10', border: 'border-red-500/20', label: 'Integration Severed', category: 'infra' },
  PROJECT_CREATE: { icon: Rocket, color: 'text-orange-500', bg: 'bg-orange-500/10', border: 'border-orange-500/30', label: 'Vault Initialized', category: 'infra' },
  // Access
  MEMBER_ADD: { icon: UserPlus, color: 'text-white', bg: 'bg-white/10', border: 'border-white/20', label: 'Access Granted', category: 'access' },
  MEMBER_REMOVE: { icon: UserMinus, color: 'text-red-600', bg: 'bg-red-600/10', border: 'border-red-600/30', label: 'Access Revoked', category: 'access' },
  TOKEN_CREATED: { icon: Key, color: 'text-orange-300', bg: 'bg-orange-300/10', border: 'border-orange-300/20', label: 'Node Token Created', category: 'access' },
  TOKEN_REVOKED: { icon: ShieldOff, color: 'text-red-500', bg: 'bg-red-500/10', border: 'border-red-500/30', label: 'Token Deleted', category: 'access' },
  // CLI
  CLI_PUSH: { icon: Terminal, color: 'text-emerald-400', bg: 'bg-emerald-500/10', border: 'border-emerald-500/30', label: 'CLI Push Entry', category: 'cli' },
  CLI_PULL: { icon: Terminal, color: 'text-emerald-500', bg: 'bg-emerald-500/10', border: 'border-emerald-500/30', label: 'CLI Pull Entry', category: 'cli' },
  CLI_HISTORY: { icon: Clock, color: 'text-gray-400', bg: 'bg-white/5', border: 'border-white/10', label: 'CLI History Query', category: 'cli' },
};

const getDefaultStyle = (action) => ({
  icon: Activity, color: 'text-gray-500', bg: 'bg-white/5', border: 'border-white/10', label: action, category: 'other'
});

export default function AuditLogs({ projectId }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState('all');
  const { usage } = useAuth();

  useEffect(() => {
    let mounted = true;
    projectsAPI.getLogs(projectId)
      .then(data => {
        if (mounted) {
          setLogs(data);
          setLoading(false);
        }
      })
      .catch(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, [projectId]);

  // CSV Export Logic
  const downloadCSV = () => {
    const headers = ["Timestamp", "Action", "User", "Details"];
    const rows = filteredLogs.map(log => [
      new Date(log.createdAt).toISOString(),
      log.action,
      log.user?.name || 'SYSTEM',
      `"${log.details?.replace(/"/g, '""') || ''}"`
    ]);

    const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `envdock_audit_log_${projectId}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Modern Filter Logic
  const filteredLogs = useMemo(() => {
    return logs.filter(log => {
      const searchStr = searchQuery.toLowerCase();
      const config = ACTION_CONFIG[log.action] || getDefaultStyle(log.action);
      
      const matchesSearch = (
        log.action?.toLowerCase().includes(searchStr) ||
        log.user?.name?.toLowerCase().includes(searchStr) ||
        log.details?.toLowerCase().includes(searchStr)
      );

      const matchesCategory = activeCategory === 'all' || config.category === activeCategory;
      return matchesSearch && matchesCategory;
    });
  }, [logs, searchQuery, activeCategory]);

  if (loading) return (
    <div className="flex flex-col items-center justify-center py-24 text-gray-700 gap-4">
      <Loader2 size={24} className="animate-spin text-orange-500" />
      <p className="text-[10px] font-black uppercase tracking-[0.3em]">Querying Ledger...</p>
    </div>
  );

  return (
    <div className="space-y-6">
      {/* --- Smart Category Toggles --- */}
      <div className="flex flex-wrap items-center gap-2 px-2 md:px-6 mt-6">
        {['all', 'vault', 'access', 'infra', 'cli'].map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`px-4 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest transition-all border ${
              activeCategory === cat 
                ? 'bg-orange-500 text-black border-orange-500 shadow-[0_0_15px_rgba(249,115,22,0.3)]' 
                : 'bg-white/5 text-gray-500 border-white/10 hover:border-white/20'
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* --- Filter & Action Header --- */}
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 bg-white/[0.01] border border-white/5 p-4 rounded-[1.5rem] mx-2 md:mx-6">
        <div className="relative group flex-1 lg:max-w-md">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-600 group-focus-within:text-orange-500 transition-colors" size={16} />
          <input
            type="text"
            placeholder="Search by user, action, or payload..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-black border border-white/10 rounded-xl pl-11 pr-4 py-3 text-[11px] text-white outline-none focus:border-orange-500/40 transition-all placeholder:text-gray-800"
          />
        </div>

        <div className="flex items-center gap-2 flex-wrap">
           <button 
            onClick={downloadCSV}
            className="w-full sm:w-auto flex items-center gap-2 px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-[10px] font-black text-white uppercase tracking-tighter hover:bg-white/10 transition-all"
           >
            <Download size={14} className="text-orange-500" /> Export CSV
          </button>

          {usage?.tier === "free" && (
            <div className="w-full sm:w-auto flex items-center gap-3 px-4 py-2 bg-orange-500/5 border border-orange-500/10 rounded-xl">
              <span className="text-[9px] font-black text-orange-500 uppercase tracking-widest leading-none">7-Day Retention</span>
              <div className="w-px h-6 bg-white/10 mx-1" />
              <Link to="/dashboard/subscription" className="text-[10px] font-black text-white hover:text-orange-500 transition-colors uppercase tracking-tighter flex items-center gap-1">
                Upgrade <ArrowRight size={12} />
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* --- Logs List --- */}
      <div className="max-h-[600px] overflow-y-auto pr-2 custom-scrollbar space-y-4 md:px-6 px-2">
        {filteredLogs.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 bg-white/[0.01] border border-dashed border-white/5 rounded-[2rem]">
            <ShieldCheck size={40} className="mb-4 text-gray-800" />
            <p className="text-[10px] font-black uppercase tracking-widest text-gray-600 text-center">
              {searchQuery ? "No matching entries found" : "Immutable Ledger Empty"}
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {filteredLogs.map((log) => {
              const style = ACTION_CONFIG[log.action] || getDefaultStyle(log.action);
              const Icon = style.icon;

              return (
                <div key={log._id} className="flex flex-col md:flex-row gap-4 p-5 rounded-[1.5rem] bg-white/[0.02] border border-white/5 hover:border-white/10 transition-all group relative">
                  <div className={`p-3 rounded-xl h-fit w-fit ${style.bg} ${style.color} border border-white/5 shrink-0`}>
                    <Icon size={18} />
                  </div>

                  <div className="flex-1 min-w-0 space-y-1">
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
                      <div className="flex items-center gap-3">
                        <p className="text-sm font-black text-white tracking-tight">{style.label}</p>
                        <span className={`text-[8px] px-2 py-0.5 rounded-md border font-black uppercase tracking-widest ${style.bg} ${style.color} ${style.border}`}>
                          {log.action}
                        </span>
                      </div>
                      <span className="text-[10px] text-gray-600 font-black uppercase tracking-widest">
                        {new Date(log.createdAt).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>

                    <p className="text-xs text-gray-500 font-medium leading-relaxed">
                      {log.details || 'System operation executed successfully.'}
                    </p>

                    <div className="flex items-center gap-3 mt-3 pt-3 border-t border-white/[0.03]">
                      <div className="w-5 h-5 rounded-md bg-white/5 border border-white/10 flex items-center justify-center text-[8px] font-black text-gray-400">
                        {log.user?.name?.charAt(0) || 'S'}
                      </div>
                      <p className="text-[10px] text-gray-500 font-bold uppercase tracking-wider">
                        EXECUTED BY <span className="text-white">{log.user?.name || 'ROOT_SYSTEM'}</span>
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}